// replaced during CI build step
export const APP_VERSION = 'v1.0-604-gbf66491';
const bffRoot = process.env.BFF_ROOT || window.location.origin;
const bffEndpoint = process.env.BFF_ENDPOINT || '/portfolio-bff';
export const BFF_HOST = `${bffRoot}${bffEndpoint}`;
export const UPSELL_QUALTRICS_BFF_ENDPOINT = `${BFF_HOST}/upsell/trigger-upsell-qualtrics`;
export const UPSELL_ANALYTICS_BFF_ENDPOINT = `${BFF_HOST}/upsell/post-upsell-analytics`;
